export default __webpack_public_path__ + "static/media/video-1.10c4ccf7.webm";